export enum BooleanTerminologyType {
  Default = 1,
  YesNoLayout,
}

export const BooleanTerminology: {
  [key in BooleanTerminologyType]: {
    falseValue: string;
    trueValue: string;
  };
} = {
  [BooleanTerminologyType.Default]: {
    falseValue: '0',
    trueValue: '1',
  },
  [BooleanTerminologyType.YesNoLayout]: {
    falseValue: $localize`:@@shared.booleanTerminology.lblNo:No`,
    trueValue: $localize`:@@shared.booleanTerminology.lblYes:Yes`,
  },
};
